// @flow strict
import * as React from 'react'
import Button from '../../atoms/Button'
import styles from './CookieAlert.module.scss'

import {
  onCookieAccept,
  hasAcceptedCookies,
  onCookieDecline,
} from '@mondough/cookie-opt-in'

export default function CookieAlert() {
  // The banner is hidden by default to prevent the sudden flashing on subsequent
  // page loads after a user has accepted
  const [hideBanner, setHideBanner] = React.useState(true)

  React.useEffect(() => {
    if (!hasAcceptedCookies()) {
      setHideBanner(false)
    }
  }, [])

  if (hideBanner) return null

  const acceptCookies = () => {
    onCookieAccept()
    setHideBanner(true)
  }

  const declineCookies = () => {
    onCookieDecline()
    setHideBanner(true)
  }

  return (
    <div className={styles.container} role="dialog">
      <div className={styles.content}>
        <div className={styles.innerContainer}>
          <div className={styles.textContainer}>
            <h2 className={styles.heading}>Can we use optional cookies?</h2>
            <p className={styles.text}>
              We're not talking about the crunchy, tasty kind. These cookies
              help us keep our website safe, give you a better experience and
              show more relevant ads. We won’t turn them on unless you accept.
              Want to know more or adjust your preferences? Here's our{' '}
              <a href="/legal/cookie-notice" target="_blank">
                cookie notice
              </a>
              .
            </p>
          </div>

          <div className={styles.buttonGroup}>
            <Button
              theme="primary"
              onClick={acceptCookies}
              className={styles.button}
            >
              Accept
            </Button>
            <Button
              theme="secondary"
              onClick={declineCookies}
              className={styles.button}
            >
              Decline
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
